import { createContext, useContext } from 'react';

export type User = {
  id: string;
  username: string;
  givenName: string;
  familyName: string;
  name: string;
  email?: string;
};

export type PermissionListType = {
  uid: string;
  id: string;
};

export type Auth0Data = {
  isAuthenticated?: boolean;
  token: string | null;
  user: User | null;
  groups: string[];
  roles: string[];
  canUseElevatedPermissions: boolean;
  useElevatedPermissions: boolean;
  setUseElevatedPermissions: (useElevatedPermissions: boolean) => void;
  apiHeaders: { [key: string]: string };
  permissionToken: string | null;
  permissionList: PermissionListType[] | null;
};

export type Auth0Actions = {
  logIn: any;
  logOut: any;
};

export type Auth0Contract = Auth0Data & {
  actions: Auth0Actions;
};

const emptyAuth0AuthFunction = (): any => Promise.resolve();

export const defaultContextValue = {
  isAuthenticated: undefined,
  token: null,
  user: null,
  roles: [],
  groups: [],
  actions: {
    logIn: emptyAuth0AuthFunction,
    logOut: emptyAuth0AuthFunction,
  },
  canUseElevatedPermissions: false,
  useElevatedPermissions: false,
  setUseElevatedPermissions: () => {},
  apiHeaders: {},
  permissionToken: null,
  permissionList: null,
};

const AuthContext = createContext<Auth0Contract>({
  ...defaultContextValue,
});

export const useAuth0 = () => useContext(AuthContext);

export default AuthContext;
